import React, { Component } from 'react';
import './Login.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import emailjs from '@emailjs/browser';
import { withTranslation } from "react-i18next";

class Newuser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nome: '',
            cognome: '',
            azienda: '',
            citta: '',
            indirizzo: '',
            email: '',
            password: '',
            confirmPassword: '',
            showPassword: false,
            showConfirmPassword: false,

            consenso: false,

            // 🟡 SOLO AGGIUNTE ANTI-BOT
            lastSubmit: 0,
            website: '',
        };

        this.onChange = this.onChange.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.togglePassword = this.togglePassword.bind(this);
        this.toggleConfirmPassword = this.toggleConfirmPassword.bind(this);
    }

    onChange(e) {
        const { name, value, type, checked } = e.target;

        this.setState({
            [name]: type === "checkbox" ? checked : value
        });
    }

    togglePassword() {
        this.setState(prevState => ({ showPassword: !prevState.showPassword }));
    }

    toggleConfirmPassword() {
        this.setState(prevState => ({ showConfirmPassword: !prevState.showConfirmPassword }));
    }

    sendEmail(e) {
        e.preventDefault();
        const { t } = this.props;

        // 🟡 HONEYPOT CHECK
        if (this.state.website) {
            toast.error("Errore invio");
            return;
        }

        // ⏱️ COOLDOWN ANTI-SPAM
        const now = Date.now();
        if (now - this.state.lastSubmit < 5000) {
            toast.error("Attendi qualche secondo prima di reinviare");
            return;
        }

        // PASSWORD CHECK
        if (this.state.password !== this.state.confirmPassword) {
            toast.error("Le password non corrispondono!", { autoClose: 2000 });
            return;
        }

        // CONSENSO CHECK
        if (!this.state.consenso) {
            toast.error("Devi accettare i termini e la privacy policy", {
                autoClose: 2500
            });
            return;
        }

        toast.info(t('pages.toast.ts1'), { autoClose: 1000 });

        const payload = {
            nome: this.state.nome,
            cognome: this.state.cognome,
            azienda: this.state.azienda,
            citta: this.state.citta,
            indirizzo: this.state.indirizzo,
            email: this.state.email,
            consenso: this.state.consenso,
        };

        const saveToDB = fetch("https://hat.sofhare.com/consenso/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        const sendMail = emailjs.sendForm(
            'service_u317szf',
            'template_4appmns',
            e.target,
            'Xl4cHzs5_rTnbe391'
        );

        Promise.all([saveToDB, sendMail])
        .then(async ([dbRes]) => {
            const dbData = await dbRes.json();

            if (!dbRes.ok) {
                toast.error(dbData.error || "Errore salvataggio DB");
                return;
            }

            toast.success(t('pages.toast.ts2'), { autoClose: 2000 });

            e.target.reset();

            this.setState({
                email: '',
                consenso: false,
                website: '',
                lastSubmit: Date.now()
            });
        })
        .catch((error) => {
            console.error(error);
            toast.error(t('pages.toast.ts3'), { autoClose: 2000 });
        });
    }

    render() {
        const { t } = this.props;

        return (
            <div>
                <ToastContainer />

                <div className="main-wrapper-login">
                    <div className="tools-wrapperS1-login">
                        <div className="login-block">

                            <h3 className="preview-title">
                                {t('pages.register.rl')}
                            </h3>

                            <form onSubmit={this.sendEmail}>

                                {/* 🟡 HONEYPOT (NON VISIBILE, NON MODIFICA UI) */}
                                <div style={{ display: "none" }}>
                                    <input
                                        type="text"
                                        name="website"
                                        value={this.state.website}
                                        onChange={this.onChange}
                                        autoComplete="off"
                                    />
                                </div>

                                <div>
                                    <input type="text" placeholder="Name"
                                        name="nome"
                                        value={this.state.nome}
                                        onChange={this.onChange}
                                        required />
                                </div>

                                <div>
                                    <input type="text" placeholder="Surname"
                                        name="cognome"
                                        value={this.state.cognome}
                                        onChange={this.onChange}
                                        required />
                                </div>

                                <div>
                                    <input type="text" placeholder="Enter your company"
                                        name="azienda"
                                        value={this.state.azienda}
                                        onChange={this.onChange} />
                                </div>

                                <div>
                                    <input type="text" placeholder="City"
                                        name="citta"
                                        value={this.state.citta}
                                        onChange={this.onChange} />
                                </div>

                                <div>
                                    <input type="text" placeholder="Address"
                                        name="indirizzo"
                                        value={this.state.indirizzo}
                                        onChange={this.onChange} />
                                </div>

                                <div>
                                    <input type="email" placeholder="Email"
                                        name="email"
                                        value={this.state.email}
                                        onChange={this.onChange}
                                        required />
                                </div>

                                {/* PASSWORD (NON TOCCATA) */}
                                <div className="password-input-container">
                                    <input
                                        type={this.state.showPassword ? "text" : "password"}
                                        placeholder="Password"
                                        name="password"
                                        value={this.state.password}
                                        onChange={this.onChange}
                                        required
                                    />

                                    <button
                                        type="button"
                                        className="toggle-password-btn"
                                        onClick={this.togglePassword}
                                    >
                                        {this.state.showPassword ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>
                                        ) : (
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                                            </svg>
                                        )}
                                    </button>
                                </div>

                                {/* CONFIRM PASSWORD (NON TOCCATA) */}
                                <div className="password-input-container">
                                    <input
                                        type={this.state.showConfirmPassword ? "text" : "password"}
                                        placeholder="Confirm Password"
                                        name="confirmPassword"
                                        value={this.state.confirmPassword}
                                        onChange={this.onChange}
                                        required
                                    />

                                    <button
                                        type="button"
                                        className="toggle-password-btn"
                                        onClick={this.toggleConfirmPassword}
                                    >
                                        {this.state.showConfirmPassword ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>
                                        ) : (
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                                            </svg>
                                        )}
                                    </button>
                                </div>

                                {/* CONSENSO (NON TOCCATO) */}
                                <div style={{ marginTop: "15px" }}>
                                    <label style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                        <input
                                            type="checkbox"
                                            name="consenso"
                                            checked={this.state.consenso}
                                            onChange={this.onChange}
                                        />
                                        <span>{t('pages.register.r6')}</span>
                                    </label>

                                    <a href="/policy.html" target="_blank" style={{ fontSize: "13px" }}>
                                        {t('pages.register.r7')}
                                    </a>
                                </div>

                                <button type="submit" className="btn-block" style={{ maxWidth: '300px' }}>
                                    {t('pages.register.r5')}
                                </button>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Newuser);